import React from "react";
import { twMerge } from "tailwind-merge";
import clsx from "clsx";

export type HeroOverlayProps = React.HTMLAttributes<HTMLDivElement>;

const HeroOverlay: React.FC<HeroOverlayProps> = ({
  className,
  children,
  ...props
}) => {
  const classes = twMerge("hero-overlay", clsx(className));

  return (
    <div {...props} className={classes}>
      {children}
    </div>
  );
};

export default HeroOverlay;
